import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
  locationReducer,
} from '../../utils/redux';

export const consts = createReqConsts('auth', 'login', ['UPDATE_PASSWORD']);
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'users/sessions',
});

export const reducer = createReqReducer(consts);
export default locationReducer(reducer);



// WEBPACK FOOTER //
// ./src/redux/auth/login.js